<div class="contract-component-container">
  <pv-admin-valet-documents
    *ngIf="candidate?.documentsStatus !== 'valid'"
    (documentUpdated)="updateDocument($event)"
    [documentsData]="documents"
    [viewAs]="USER_ROLE.CANDIDATE"
    [candidate]="candidate"
    [hideContract]="true"
    [valet]="valet"></pv-admin-valet-documents>
</div>
<div class="recruitment-contract-status-message">
  <div *ngIf="candidate?.documentsStatus === 'missing' && candidate?.contractStatus === 'missing'">
    <nb-alert outline="info">
      <div class="d-flex align-items-center">
        <div class="mr-3">
          <nb-icon icon="info-circle" status="info" style="font-size:2rem;"></nb-icon>
        </div>
        <div class="d-flex flex-column">
          <span>
            {{'recruitment.process.request_documents' | translate}}
          </span>
        </div>
      </div>
    </nb-alert>
    <nb-alert outline="warning">
      <div class="d-flex align-items-center">
        <div class="mr-3">
          <nb-icon icon="pause-circle" status="warning" style="font-size:2rem;"></nb-icon>
        </div>
        <div class="d-flex flex-column">
          <span>
            {{'recruitment.process.documents_missing' | translate}}
          </span>
        </div>
      </div>
    </nb-alert>
  </div>
  <div *ngIf="candidate?.documentsStatus === 'pending' && candidate?.contractStatus === 'missing'">
    <nb-alert outline="success">
      <div class="d-flex align-items-center">
        <div class="mr-3">
          <nb-icon icon="check-circle" status="success" style="font-size:2rem;"></nb-icon>
        </div>
        <div class="d-flex flex-column">
          <span>
            {{'recruitment.process.documents_pending_info' | translate}}
          </span>
        </div>
      </div>
    </nb-alert>
  </div>
  <div *ngIf="candidate?.documentsStatus === 'valid' && candidate?.contractStatus === 'missing'">
    <nb-alert outline="info">
      <div class="d-flex align-items-center">
        <div class="mr-3">
          <nb-icon icon="info-circle" status="info" style="font-size:2rem;"></nb-icon>
        </div>
        <div class="d-flex flex-column">
          <span>
            {{'recruitment.process.request_contract' | translate}}
          </span>
        </div>
      </div>
    </nb-alert>
    <nb-alert outline="info">
      <div class="d-flex align-items-center">
        <div class="mr-3">
          <nb-icon icon="info-circle" status="info" style="font-size:2rem;"></nb-icon>
        </div>
        <div class="d-flex flex-column">
          <span>
            {{'recruitment.process.request_patience' | translate}}
          </span>
        </div>
      </div>
    </nb-alert>
    <nb-alert outline="warning">
      <div class="d-flex align-items-center">
        <div class="mr-3">
          <nb-icon icon="pause-circle" status="warning" style="font-size:2rem;"></nb-icon>
        </div>
        <div class="d-flex flex-column">
          <span>
            {{'recruitment.process.contract_missing' | translate}}
          </span>
        </div>
      </div>
    </nb-alert>
  </div>
</div>

<div *ngIf="candidate?.documentsStatus === 'valid'" class="doc_viewer">
  <ng-container *ngIf="lastTerms">
    <ngx-doc-viewer viewer="pdf" [url]="lastTerms.url">
    </ngx-doc-viewer>
    <div *ngIf="valet" class="d-flex justify-content-center">
      <button *ngIf="!valet.approvedGeneralTerms"
              nbButton
              status="primary"
              [disabled]="acceptingGeneralTerms"
              [nbSpinner]="acceptingGeneralTerms"
              (click)="acceptGeneralTerms()">
        {{'recruitment.process.step.general_terms.approve' | translate}}
      </button>
      <nb-alert outline="success" *ngIf="valet.approvedGeneralTerms">
        <div class="d-flex align-items-center">
          <div class="mr-3">
            <nb-icon icon="check-circle" status="success" style="font-size:2rem;"></nb-icon>
          </div>
          <div class="d-flex flex-column">
            <span>
              {{'recruitment.process.contract_valid' | translate}}
            </span>
          </div>
        </div>
      </nb-alert>
    </div>
  </ng-container>
  <ng-container *ngIf="!lastTerms">
    <span>{{'client.modules.users.general_terms_waiting_text' | translate}}</span>
  </ng-container>
</div>

